import { apiClient } from './api';
import type { Banka, CreateBankaRequest, UpdateBankaRequest } from '../types/banka';

export const bankaService = {
  getAll: async (): Promise<Banka[]> => {
    const response = await apiClient.get<Banka[]>('/Bankalar');
    return response.data;
  },

  getById: async (id: string): Promise<Banka> => {
    const response = await apiClient.get<Banka>(`/Bankalar/${id}`);
    return response.data;
  },

  create: async (data: CreateBankaRequest): Promise<string> => {
    const response = await apiClient.post<string>('/Bankalar', data);
    return response.data;
  },

  update: async (data: UpdateBankaRequest): Promise<void> => {
    await apiClient.put(`/Bankalar/${data.id}`, data);
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/Bankalar/${id}`);
  },
};
